import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getEcs } from "../../store/actions/ecss_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/ecss_enum";
import SingleView from "../../components/common/SingleView";
const ViewEcs = ({ getEcs, match, ecs: { loading, ecs } }) => {
  useEffect(() => {
    getEcs(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          ecs && (
            <SingleView
              data={ecs}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={ecs.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ ecs: state.ecs });

const mapDispatchToProps = { getEcs };

export default connect(mapStateToProps, mapDispatchToProps)(ViewEcs);
